<header
	class="site-header"
	id="site-header"
>
	<div class="site-header__container">
		<div class="site-header__brand">
			<a
				[routerLink]="['/']"
				routerLinkActive="router-link-active"
				class="site-header__site-link"
			>Dartegnian.com
			</a>
		</div>
		<nav class="site-header__nav">
			<ul class="site-header__nav-list">
				<li class="site-header__nav-item"><a [routerLink]="['/']" class="site-header__nav-link">Home</a></li>
				<li class="site-header__nav-item"><a href="https://blog.dartegnian.com/" class="site-header__nav-link">Blog</a></li>
			</ul>
		</nav>
	</div>
</header>